
import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions } from "../../../_actions";
import StudentHeader from "./Component/StudentHeader";
// import NewStudentModal from "./Component/NewStudentModal"
import Select from 'react-select';
import ReactEcharts from "echarts-for-react";
import { IoIosSearch } from "react-icons/io";
import { LiaFileExcel } from "react-icons/lia";
import { PiStudent } from "react-icons/pi";
import { TbPasswordUser } from "react-icons/tb";
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment';

class StudentDashboard extends Component {
  constructor(props) {
    super(props);
    this.handleDownloadExcel = this.handleDownloadExcel.bind(this);
    this.state = {
      error: '',
      schoolId: '',
      showCreateStudentModal: false,
      isDropdownOpen: false,
      view: 'Table',
      formStudentData: {
        "name": "",
        "email": "",
        "mobile": ""
      },
      size: 10,
      crrStudentId: this.props.match.params.id

    };
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.getDashboardAnalytics({
      type: 1
    }));
    let paginationData = {
      "keyWord": "",
      "pageNo": 1,
      "size": this.state.size
    }
    let paginationData2 = {
      "keyWord": "",
      "pageNo": 1,
      "size": this.state.size
    }
    this.props.dispatch(assessmentActions.getSchoolList(paginationData, paginationData2, true));
    window.scrollTo(0, 0);
  }

  handleViewChange = (event) => {
    this.setState({ view: event.target.value });
  };

  handleUpdateStudentModal = (value) => {
    this.setState({ updateStudentModal: value });
  };

  handleEditStudentModal = (value) => {
    let data = {
      "id": value.id,
      "name": value.name,
      "email": value.email,
      "mobile": value.mobile
    }
    this.setState({ updateFormStudentData: data, updateStudentModal: value });
  };

  handleDeleteStudentModal = (value) => {
    this.setState({ deleteStudentModal: value });
  };

  gotoPage2 = (field) => {
    const { history } = this.props;
    history.push(`/assessment/${field}`);
  };


  handleStudentInput = (event) => {
    let { formStudentData } = this.state;
    formStudentData[event.target.name] = event.target.value;
    this.setState({ formStudentData });
  };

  saveNewStudent = () => {
    let { name, email, mobile } = this.state.formStudentData;
    let data = {
      "name": name,
      "email": email,
      "mobile": mobile
    }

    let paginationData = {
      "keyWord": "",
      "pageNo": 1,
      "size": this.state.size
    }
    this.props.dispatch(assessmentActions.createStudent(data, paginationData));

    setTimeout(() => {
      this.setState({
        formStudentData: {
          "name": "",
          "email": "",
          "mobile": ""
        },
        showStudentModal: false
      })
    }, 500)
  }

  handleUpdateStudentInput = (event) => {
    let { updateFormStudentData } = this.state;
    updateFormStudentData[event.target.name] = event.target.value;
    this.setState({ updateFormStudentData });
  };

  saveUpdateStudent = () => {
    let { id, name, email, mobile } = this.state.updateFormStudentData;
    let data = {
      "id": id,
      "name": name,
      "email": email,
      "mobile": mobile
    }

    let paginationData = {
      "keyWord": "",
      "pageNo": 1,
      "size": this.state.size
    }
    this.props.dispatch(assessmentActions.updateStudent(data, paginationData));

    setTimeout(() => {
      this.setState({
        updateFormStudentData: {
          "id": "",
          "name": "",
          "email": "",
          "mobile": ""
        },
        updateStudentModal: false
      })
    }, 500)
  }

  onSelectSchool = (data) => {
    // console.log('data12313213213213213131313213131313112', data);
    let paginationData = {
      "keyWord": "",
      "pageNo": 1,
      "size": this.state.size,
      "schoolId": data.value
    }
    this.setState({ schoolId: data.value, error: '', });
    this.props.dispatch(assessmentActions.getStudentList(paginationData));
  }

  handleSearchStudent = (event, data) => {
    event.preventDefault();
    let { value } = event.target;
    const { schoolId } = this.state;
    if (!schoolId) {
      this.setState({
        error: 'Please select School first',
      });
    } else {
      this.setState({
        searchEmployee: value, data, error: ''
      }, () => {
        let paginationData = {
          "keyWord": value,
          "pageNo": 1,
          "size": this.state.size,
          "schoolId": this.state.schoolId
        }
        this.props.dispatch(assessmentActions.getStudentList(paginationData));
      });
    }
  }

  handleDownloadExcel() {
    const { getStudentListData } = this.props.assessment;

    // Prepare data for Excel
    const data = getStudentListData.map((student, index) => ({
      SNo: index + 1,
      Name: student.name || "",
      Class: student.std_class || "",
      Email: student.email || "",
      AssessmentCode: student.purchaserOrderId && student.purchaserOrderId.otpCode ? student.purchaserOrderId.otpCode : "Not Assigned",
      Status: student.status || "Not Assigned",
    }));

    // Create a worksheet from the data
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Students");

    // Write the file
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), "students.xlsx");
  }


  render() {

    let { assessment } = this.props;
    let { view } = this.state;
    let { getSchoolListData, getStudentListData, getDashboardAnalyticsData } = assessment;

    let colourOptions = [];
    if (getSchoolListData && getSchoolListData.length > 0) {
      colourOptions = getSchoolListData.map((ele) => ({
        value: ele.id,
        label: ele.name
      }))
    }

    const checkFormat = (ele, field) => {
      return ele && ele[field] ? ele[field] : ""
    }

    const data_student = getStudentListData && getStudentListData.length > 0 ? getStudentListData.map((ele) => ({
      id: checkFormat(ele, "id"),
      name: checkFormat(ele, "name"),
      std_class: checkFormat(ele, "std_class"),
      email: checkFormat(ele, "email"),
      mobile: checkFormat(ele, "mobile"),
      date: checkFormat(ele, "createdAt")
        ? moment(checkFormat(ele, "createdAt"))
          .utcOffset("+05:30")
          .format("DD/MM/YYYY")
        : "",
      code: ele && ele.purchaserOrderId && ele.purchaserOrderId.otpCode ? ele.purchaserOrderId.otpCode : "",
      status: 'Not Assigned'
    })) : []


    return (
      <>
        <StudentHeader />

        <div className="flex items-start justify-center pb-10 bg-[#FAFAFA] h-screen">
          <section className="px-4 xl:w-11/12 mx-auto w-full xl:px-0">

            <div className="my-4 w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              <div className="bg-white border border-[#E8E8E8] rounded-lg p-4">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <h3 className="text-base font-normal text-gray-500">Total Schools</h3>
                    <span className="text-2xl sm:text-3xl leading-none font-semibold text-gray-900">{getDashboardAnalyticsData && getDashboardAnalyticsData.schoolCount ? getDashboardAnalyticsData.schoolCount : 0}</span>
                  </div>
                  <div className="flex items-center justify-end flex-1 text-[#2196F3] text-base font-bold">
                    <img src="/assessment_images/School/total-school.svg" alt="total-school.svg" className="w-16 h-16" />
                  </div>
                </div>
              </div>
              <div className="bg-white border border-[#E8E8E8] rounded-lg p-4">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <h3 className="text-base font-normal text-gray-500">Total Students</h3>
                    <span className="text-2xl sm:text-3xl leading-none font-semibold text-gray-900">{getDashboardAnalyticsData && getDashboardAnalyticsData.studentCount ? getDashboardAnalyticsData.studentCount : 0}</span>
                  </div>
                  <div className="flex items-center justify-end flex-1 text-[#2196F3] text-base font-bold">
                    <PiStudent className="w-16 h-16" />
                  </div>
                </div>
              </div>
              <div className="bg-white border border-[#E8E8E8] rounded-lg p-4">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <h3 className="text-base font-normal text-gray-500">Total Assessment Codes</h3>
                    <span className="text-2xl sm:text-3xl leading-none font-semibold text-gray-900">{getDashboardAnalyticsData && getDashboardAnalyticsData.codesCount ? getDashboardAnalyticsData.codesCount : 0}</span>
                  </div>
                  <div className="flex items-center justify-end flex-1 text-[#2196F3] text-base font-bold">
                    <TbPasswordUser className="w-16 h-16" />
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white border border-[#E8E8E8] p-4 rounded-lg">
              {/* Table design secction */}
              <div className="w-full flex-1 space-y-4">
                <div className="items-stretch justify-between space-y-4 lg:flex md:space-y-0">
                  <div className="flex space-x-3 items-center">
                    <div className="space-y-1">
                      <div className="relative w-full ">
                        <Select className="w-56 text-[#212121] text-sm font-medium"
                          options={colourOptions}
                          defaultValue={colourOptions[0]}
                          placeholder="Select Student"
                          onChange={this.onSelectSchool}
                        />
                      </div>
                    </div>

                    <div className="flex space-x-2 capitalize items-center text-sm text-[#212121]/70 font-medium">
                      <span>Show</span>
                      <form class="w-16">
                        <select id="entries" class="bg-white border border-gray-300 text-[#212121] text-sm rounded-md block w-full px-2 py-2 focus:outline-none">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </form>
                      <span>entries</span>
                    </div>
                  </div>

                  <div className="flex space-x-3">
                    <div className="w-full">
                      <div className="w-full flex justify-between border py-0.5 px-4 text-[#212121]/70 bg-white rounded-md text-sm items-center overflow-hidden">
                        <IoIosSearch className="w-5 h-5" />
                        <input type="search" name="search" onChange={this.handleSearchStudent} placeholder="Search by name" className="w-44 focus:outline-none px-2 py-2 text-[#212121]/70 placeholder-[#212121]/70 placeholder:font-normal font-medium " />
                      </div>
                      {this.state.error && <p className="text-red-500 text-xs">{this.state.error}</p>}
                    </div>

                    <div onClick={this.handleDownloadExcel} className="flex items-center py-2 px-4 text-sm border whitespace-nowrap rounded-md cursor-pointer font-medium text-[#212121]/70 md:w-auto w-full" >
                      <span className="mr-2">
                        <LiaFileExcel className="w-5 h-5" />
                      </span> Download Excel
                    </div>

                    {/* <div className="flex capitalize items-center text-sm text-[#212121]/70 font-medium">
                      <select id="entries" onChange={this.handleViewChange} value={view} class="bg-white border border-gray-300 text-gray-900 text-sm rounded-md block px-2 py-2.5 focus:outline-none">
                        <option value="Table">Table View</option>
                        <option value="Graph">BarChart View</option>
                      </select>
                    </div> */}

                  </div>
                </div>

                {view === 'Table' &&
                  <div className="w-full mx-auto">
                    <div className="inline-block min-w-full">
                      <table className="min-w-full border">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="px-3 w-20 py-3 text-center border text-sm font-semibold text-gray-900">S.No.</th>
                            <th className="px-3 py-3 text-left border text-sm font-semibold text-gray-900">Students Name</th>
                            <th className="px-3 py-3 text-center border text-sm font-semibold text-gray-900">Class</th>
                            <th className="px-3 py-3 text-left border text-sm font-semibold text-gray-900">Student Email</th>
                            <th className="px-3 py-3 text-center border text-sm font-semibold text-gray-900">Assessment Code</th>
                            <th className="px-3 py-3 text-center border text-sm font-semibold text-gray-900">Status</th>
                          </tr>
                        </thead>
                        <tbody className="border divide-gray-200 bg-white">
                          {data_student && data_student.length > 0 ? (
                            data_student.map((item, index) => (
                              <tr className="hover:bg-gray-100" key={index}>
                                <td className="whitespace-nowrap px-2 py-2 border text-sm text-center">{index + 1}</td>
                                <td className="whitespace-nowrap px-2 py-2 border text-sm">{item.name}</td>
                                <td className="whitespace-nowrap px-2 py-2 border text-sm text-center">{item.std_class}</td>
                                <td className="whitespace-nowrap px-2 py-2 border text-sm">{item.email}</td>
                                <td className="whitespace-nowrap px-2 py-2 border text-sm">
                                  {item && item.code ? (
                                    <div className="flex items-center justify-center">
                                      <div className="space-x-2 flex items-center justify-center">
                                        <p className="border-dashed border-2 px-3 py-1 w-32 rounded-md text-center border-[#4CAF50] bg-[#4CAF50]/20 text-[#4CAF50] font-medium">
                                          {item.code}
                                        </p>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="flex items-center justify-center">
                                      <div
                                        id="entries"
                                        className={`bg-gray-50 border cursor-pointer border-gray-300 text-center text-gray-900 text-sm rounded-md w-32 px-3 py-1.5 focus:outline-none ${item && item.status === "Completed"
                                          ? "bg-green-500 text-white"
                                          : item && item.status === "Pending"
                                            ? "bg-yellow-500 text-white"
                                            : "bg-white text-gray-900"
                                          }`}
                                      >
                                        Not Assigned
                                      </div>
                                    </div>
                                  )}
                                </td>

                                <td className="whitespace-nowrap px-2 py-2 border text-sm w-44">
                                  <div className="flex items-center justify-center">
                                    <div
                                      id="entries"
                                      className={`bg-gray-50 border cursor-pointer border-gray-300 text-center text-gray-900 text-sm rounded-md w-32 px-3 py-1.5 focus:outline-none ${item && item.status === "Completed"
                                        ? "bg-green-500 text-white"
                                        : item && item.status === "Pending"
                                          ? "bg-yellow-500 text-white"
                                          : "bg-white text-gray-900"
                                        }`}
                                    >
                                      {item.status}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="9" className="px-4 py-8 text-center">
                                <div className="flex flex-col items-center space-y-4 justify-center md:py-8 py-6">
                                  <img src="/assessment_images/no-users.svg" alt="no-users" className="w-36 2xl:w-40" />
                                  <h2 className="capitalize md:text-3xl text-2xl font-semibold text-[#3D405B] pt-4">Data not found!</h2>
                                  <p className="text-gray-500 text-lg">Looks like you haven’t added any user yet.</p>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                }

                {/* {view === 'Graph' &&
                  <section className="border rounded-md">
                    <ReactEcharts style={{ width: '100%', height: '420px', paddingTop: '15px' }}
                      option={{
                        legend: {},
                        tooltip: {},
                        dataset: {
                          source: [
                            ['SchoolName', 'No.Of Student', 'Assigned Code', 'Assessment Code'],
                            ['A', 43, 85, 93],
                            ['B', 83, 73, 55],
                            ['C', 86, 65, 82],
                          ]
                        },
                        xAxis: {},
                        yAxis: { type: 'category' },
                        // Declare several bar series, each will be mapped
                        // to a column of dataset.source by default.
                        series: [
                          { type: 'bar', barWidth: 20 },
                          { type: 'bar', barWidth: 20 },
                          { type: 'bar', barWidth: 20 }
                        ]
                      }}
                    />
                  </section>} */}
              </div>
            </div>
          </section>
        </div>


      </>
    );
  }
}

StudentDashboard.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};
function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, user, assessment } = state;
  return {
    loggingIn,
    questions,
    user,
    assessment,
  };
}

export default connect(mapStateToProps)(StudentDashboard);
